import { useState } from 'react'
import { subscribePathName, setPathName } from '../router'

let activeTab = '0'
let setActiveTab = () => {}

// 由 tabs 组件触发
const handleTabChange = (e, val) => {
    setActiveTab(val)
    // 如果是切回主线包管理，去掉url中附加的 upload_management 路径
    if (val === '0') {
        setPathName('/static')
    } else {
        setPathName('/static/upload_management')
    }
}
window.setActiveTab = setActiveTab
window.setPathName = setPathName

const isStaticPageActive = () => String(activeTab) === '0'

const listenUrlChange = (e, _path) => {
    const path = _path || window.location.pathname
    if (path.includes('/upload_management') && isStaticPageActive()) {
        setActiveTab('1')
    } else if ((path === '/' || path === '/static') && !isStaticPageActive()) {
        setActiveTab('0')
    }
}
window.addEventListener('popstate', listenUrlChange)

// app中有其它页面调用了 setPathName，这里需要跟着切换
subscribePathName(path => {
    listenUrlChange(null, path)
})

export const useLayoutTabs = () => {
    const [_activeTab, _setActiveTab] = useState(activeTab)
    activeTab = _activeTab
    setActiveTab = _setActiveTab
    listenUrlChange()
    return { activeTab, setActiveTab, handleTabChange, listenUrlChange }
}

export default useLayoutTabs
